<template>
  <component
    :is="tag"
    class="productcard-wrapper"
  >
    <ProductSpecs
      :product="product"
      class="specs"
    />
    <ProductInfo :product="product" />
    <ProductCountDown
      v-if="isSubscriptionPeriod() && $store.state.attributes.enable_countdowns === true"
      :product="product"
    />
    <p
      v-if="$content.legal"
      class="legal-note"
    >
      {{ $content.legal }}
    </p>
  </component>
</template>
<script>
import ProductInfo from '@/components/utils/product/ProductInfo.vue';
import ProductSpecs from '@/components/layouts/products/blocks/ProductSpecs.vue';
import ProductCountDown from '@/components/layouts/products/blocks/ProductCountDown.vue';
import TimerMixin from '@/mixins/TimerMixin.vue';

export default {
  name: 'ProductCard',
  components: {
    ProductInfo,
    ProductCountDown,
    ProductSpecs,
  },
  mixins: [TimerMixin],
  props: {
    product: {
      type: Object,
      required: true,
    },
    tag: {
      type: String,
      default: 'div',
    },
  },
};
</script>
<style lang="stylus" scoped>
.productcard-wrapper {
  display: flex;
  flex-direction: column;
  padding-bottom: 20px
  gap: 20px;
  width: 100%;
  +desktop() {
    width: 245px;
  }
}
</style>
<style scoped>
  .productcard-wrapper .legal-note {
    background: color-mix(in srgb, var(--main-color) 10%, transparent);
    font-size: 10px;
    color: var(--inverted-text-color);
    height: auto;
    width: 100%;
    border-radius: 10px 14px;
    padding: 10px;
    margin: 0;
  }
</style>
